import { Button } from "@/components/shadcn/button";
import { LanguageProvider } from "@/contexts/LanguageProvider";
import axiosInstance from "@/lib/axiosInterceptor";
import { gtag } from "@/utils/adsense/gtag";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import { Modal } from "../Modal/Modal";
import { Translate } from "../Translate/Translate";

export const OutdatedVersionModal = () => {
    const [showModal, setShowModal] = useState(false);
    const checkApplicationVersion = async () => {
        try {
            const {
                data: { version },
            } = await axiosInstance.get<{ version: string }>(`/api/application-version`);
            if (version !== process.env.NEXT_PUBLIC_APPLICATION_VERSION) {
                gtag("event", "outdated_version_modal", {
                    page: window.location.href,
                });
                setShowModal(true);
            }
        } catch (e) {}
    };
    const close = () => setShowModal(false);
    useEffect(() => {
        checkApplicationVersion();
    }, []);
    return (
        <LanguageProvider files={["common"]}>
            <Modal isOpen={showModal}>
                <div className="flex justify-center items-center px-8 h-screen">
                    <div
                        className="relative inline-flex flex-col items-center bg-white dark:bg-darkSurface-300 rounded-lg py-12 px-8 gap-4 text-center"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <X className="absolute right-2 top-2 cursor-pointer" onClick={close} />
                        <div className="font-semibold text-lg">
                            <Translate keyName="common:outdated-version-modal-title" />
                        </div>
                        <div>
                            <Translate
                                keyName="common:outdated-version-modal-description"
                                linkRenderer={(label) => (
                                    <a
                                        className="font-semibold underline cursor-pointer text-irBlue-200"
                                        href="https://www.refreshyourcache.com/en/home/"
                                        target="_blank"
                                        referrerPolicy="no-referrer"
                                    >
                                        {label}
                                    </a>
                                )}
                            />
                        </div>
                        <div>
                            <Translate keyName="common:outdated-version-modal-outro" />
                        </div>
                        <Button
                            className="bg-irBlue-400 text-white hover:bg-irBlue-200 uppercase mt-4 -mb-4 px-8"
                            onClick={close}
                        >
                            <Translate keyName="common:ok" />
                        </Button>
                    </div>
                </div>
            </Modal>
        </LanguageProvider>
    );
};

const Content = () => {};
